import { constants } from "@newsela/angelou";

import { IAnnotationStyle } from "../TextHighlighting.interface";
import { TAnnotationColorsIndex } from "../TextHighlighting.style";

const { ui } = constants.colors;

interface IGuidedHighlightingStyles {
  correct: IAnnotationStyle;
  incorrect: IAnnotationStyle;
  default: {
    penName: TAnnotationColorsIndex;
    background: string;
    borderColor: string;
    textColor: string;
    badgeColor: string;
  };
}

export const GUIDED_HIGHLIGHTING_ANNOTATION_STYLES: IGuidedHighlightingStyles =
  {
    correct: { penName: "springgreen" },
    incorrect: {
      penName: "red",
      background: ui.pink[25],
      borderColor: ui.pink[400],
    },
    default: {
      penName: "blue",
      background: ui.core[25],
      borderColor: ui.purple[400],
      textColor: ui.core[25],
      badgeColor: ui.purple[400],
    },
  };
